import { PROMO_URLS } from '../helpers/api/API_URLS';
import { basicGET } from '../helpers/api/fetchParams';

export async function getAllPromotions() {
    var token = localStorage.getItem("token");
    const response = await fetch(PROMO_URLS.listAllPromotions, basicGET(token));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    // console.log(data)
    return data.result;
}

export async function getClientPromotions(clientCode) {
    var token = localStorage.getItem("token");
    const response = await fetch(PROMO_URLS.API+"promos/all/"+clientCode, basicGET(token));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data.result;
}

export async function getPromotionById(promoId) {
    var token = localStorage.getItem("token");
    const response = await fetch(PROMO_URLS.promo+promoId, basicGET(token));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


// WEBPACK FOOTER //
// ./src/data/servicePromotions.js